import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../../component/Header";
import BottomNav from "../../component/BottomNav";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";

import SearchBookList from "../../component/SearchBookList";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class SVByYear extends Component {

	constructor(props) {
		super(props);

		var itms = new Map();
		itms["m_chk1"] = false;
		itms["m_chk2"] = false;
		itms["m_chk3"] = false;
		itms["m_chk4"] = false;

		this.state = {
			totalcount: 0, curpageidx: 0,
			checkedItems: itms,
			headerTitle: "더책-연령",
			query: "",
			loading: true,
			data: [],
			booklist: [],
			self: this, sortway: 1, sortorder: 1
		};

		this.handleChange_onCheckBox = this.handleChange_onCheckBox.bind(this);
		this.doSort = this.doSort.bind(this);

		this.dofetchdata('', true);
	}

	componentWillMount() {
		var self = this;
		window.addEventListener('scroll', function () {
			if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
				console.log("you're at the bottom of the page");
				if (self.state.loading === false) {
					self.dofetchdata('', false);
				}
			}
		});
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll, true);
	}


	dofetchdata(strages, binit) 
	{
		if (binit === false && this.state.booklist.length >= this.state.totalcount)
			return;

		this.state.loading = true;

		fetch(`/api/AB/BookList?pgidx=0&pgsize=50&orderby=${this.state.sortorder}&orderway=${this.state.sortway}&agelist=${strages}`)
			.then(response => response.json())
			.then(data => {
				const { query } = this.state;
				//const booklist = data.lstresult;

				
				this.state.loading = false;
				if (binit === true) {
					this.state.curpageidx = 0;
					this.state.booklist = data.lstresult;
					this.state.curpageidx++;
				}
				else {
					this.state.curpageidx++;
					this.state.booklist.push(...data.lstresult);
				}
					

				//alert(JSON.stringify(data.lstresult));
				console.log(JSON.stringify(data.lstresult));

				this.setState({ totalcount: data.totalcount, curpageidx: this.state.curpageidx, booklist: this.state.booklist, loading: false });
			});
	};

	handleChange_onCheckBox(e) {
		const item = e.target.name;
		const isChecked = e.target.checked;

		console.log("item: " + e.target.name + ", checked: " + isChecked);

		this.state.checkedItems[item] = isChecked;

		//console.log(JSON.stringify(this.state.checkedItems));
		//console.log(JSON.stringify(this.state));

		var agelist = '';
		if (this.state.checkedItems['m_chk1'] === true) {
			agelist += "|10|20|";
		}
		if (this.state.checkedItems['m_chk2'] === true) {
			agelist += "|30|40|";
		}
		if (this.state.checkedItems['m_chk3'] === true) {
			agelist += "|50|60|";
		}
		if (this.state.checkedItems['m_chk4'] === true) {
			agelist += "|70|";
		}
		console.log('ages: ' + agelist);

		var self = this.state.self;

		self.dofetchdata(agelist, true);
	}

	doSort(e) {
		var ns = e.currentTarget.name;
		var sortway = 1;
		var sortorder = 1;
		if (ns === 1) {
			sortway = 0;
			sortorder = 0;
		}
		else if (ns === 2) {
			sortway = 0;
			sortorder = 1;
		}
		else if (ns === 4) {
			sortway = 1;
			sortorder = 0;
		}
		else if (ns === 3) {
			sortway = 1;
			sortorder = 1;
		}

		this.state.sortorder = sortorder;
		this.state.sortway = sortway;

		this.dofetchdata('', true);
	}

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        this.logPageView();
		//let contents = this.state.loading === true ? "loading..." : this.dorender();
		let contents = "loading...";

		return (
			<React.Fragment>
				<Header headerTitle={this.state.headerTitle} />
				<ExpansionPanelDetails>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<div className="form-group">
								<h4 className="form-label">연령</h4>
								<FormControlLabel
									control={<Checkbox value="10|20" color="primary" name="m_chk1" onChange={this.handleChange_onCheckBox} checked={this.state.checkedItems.get('m_chk1')} />}
									label="영유아"
								/>
								<FormControlLabel
									control={<Checkbox value="40|50" color="primary" name="m_chk2" onChange={this.handleChange_onCheckBox} checked={this.state.checkedItems.get('m_chk3')} />}
									label="초등"
								/>
								<FormControlLabel
									control={<Checkbox value="60|70" color="primary" name="m_chk3" onChange={this.handleChange_onCheckBox} checked={this.state.checkedItems.get('m_chk4')} />}
									label="중/고등학교"
								/>
								<FormControlLabel
									control={<Checkbox value="80" color="primary" name="m_chk4" onChange={this.handleChange_onCheckBox} checked={this.state.checkedItems.get('m_chk5')} />}
									label="성인"
								/>
							</div>
						</Grid>
					</Grid>
				</ExpansionPanelDetails>
				<ExpansionPanelDetails>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<div className="form-group">
								<h4 className="form-label">정렬</h4>
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="1">
									ㄱ-ㅎ 순
								</Button>
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="2">
									ㅎ-ㄱ 순
								</Button>
								&nbsp;&nbsp;
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="3">
									최신순
								</Button>
								<Button variant="contained" className="btn-sm" onClick={this.doSort} name="4">
									역순
								</Button>
							</div>
						</Grid>
					</Grid>
				</ExpansionPanelDetails>
				<div className="section-body">
					<React.Fragment>
						<ul className="bookList">
							{this.state.booklist.map((book, index) => {
								return (
									<React.Fragment>
										<li className="bookList-item">
											<Link to={`/book/${book.id}`}>
												<div className="bookList-thumbnail">
													<div className="thumbnail">
														<img
															className="thumbnail-image"
															src={`/api/AB/GetCoverImage?thumb=2&imgid=${book.id}`}
															alt={book.subject}
														/>
													</div>
												</div>
												<div className="bookList-info">
													<h3 className="bookList-title">{book.subject}</h3>
													<h4 className="bookList-author">{book.authorName}</h4>
													<h4 className="bookList-publisher">{book.publisherName}</h4>
												</div>
											</Link>
										</li>
									</React.Fragment>
								);
							})}
						</ul>
					</React.Fragment>
					
				</div>
			</React.Fragment>
		);
	}
}

export default SVByYear;
